export const OWNER_ROLE = 1;
export const MANAGER_ROLE = 2;
export const MEMBER_ROLE = 3;
export const ROLES = {
    [OWNER_ROLE]: 'Капитан',
    [MANAGER_ROLE]: 'Менеджер',
    [MEMBER_ROLE]: 'Игрок',
};

export const OWNER_CODE = 'owner';
export const MANAGER_CODE = 'manager';
export const MEMBER_CODE = 'member';

export const ROLE_TITLES_BY_CODE = {
    [OWNER_CODE]: 'Капитан',
    [MANAGER_CODE]: 'Менеджер',
    [MEMBER_CODE]: 'Игрок',
};

// Бэкенд кладёт в role_in_team.name сырой ключ локализации (lists-teamMemberRole.owner),
// поэтому подпись собираем на фронте по code, а name разбираем только как запасной вариант.
export function getTeamMemberRoleTitle(role) {
    if (!role) return '—';
    const code = role.code || String(role.name || '').split('.').pop();
    return ROLE_TITLES_BY_CODE[code] || role.name || '—';
}
